import { Button, Input, Typography } from '@finam/web-ui-kit';
import React from 'react';
import { CardData } from '../../Services/ResponseData';
import { WebService } from '../../Services/WebService';
import { TokenContext } from '../../TokenContext';
import SelectWithChoice from './SelectWithChoice';

interface IProps {
    onSave: (val: { bankId: number, account: string }) => void
}

interface IState {
    cardId: number,
    bankId: number,
    bankBic?: string,
    account: string,
    loadedBanks: { bankId: number, bic: string, bankName: string, bankFullName: string }[]
    options: { key: string, value: string }[]
    currentInput: string
    accountChanged?: boolean
}

export default class BankAccountField extends React.Component<IProps, IState> {
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;
    private accountNumberInput: React.RefObject<HTMLInputElement>;

    constructor(props: IProps) {
        super(props);
        this.accountNumberInput = React.createRef();
        this.state = {
            account: '',
            cardId: 0,
            bankId: 0,
            loadedBanks: [],
            options: [],
            currentInput: '',
            bankBic: ''
        }
    }

    componentDidMount(): void {
        const ws = new WebService(this.context.token);
        ws.GetBanks().then(
            res => {
                this.setState({
                    loadedBanks: res,
                    options: res.map(bo => ({ key: bo.bankId?.toString(), value: `${bo.bic} - ${bo.bankName}` })),
                });
                ws.GetCard().then(card => {
                    if (!!card) {
                        const selectedBank = res.find(b => b.bankId == card.bankId);
                        this.setState({
                            bankId: card.bankId,
                            account: card.accountNum,
                            cardId: card.cardId,
                            currentInput: !!selectedBank ? `${selectedBank.bic} - ${selectedBank.bankName}` : ''
                        })
                    }
                });
            }
        );
    }

    private onInputChange(value: string) {
        const filteredOptions = this.state.loadedBanks.filter(i => i.bic.toLowerCase().indexOf(value.toLowerCase()) > -1 || i.bankName.toLowerCase().indexOf(value.toLowerCase()) > -1);
        this.setState({
            options: filteredOptions.map(bo => ({ key: bo.bankId?.toString(), value: `${bo.bic} - ${bo.bankName}` })),
            currentInput: value
        })
    }

    private onAccountChange(value: string) {
        if (value.length > 20)
            return;
        this.setState({ account: value, accountChanged: true })
    }

    private onSelectOption(key: string) {
        if (!!key) {
            const bank = this.state.loadedBanks.find(b => b.bankId == parseInt(key));
            this.setState({ bankId: bank?.bankId || 0, currentInput: `${bank?.bic} -${bank?.bankName}` || '', bankBic: bank?.bic, accountChanged: true });
        }
    }

    render() {
        return <div className='baFieldWrapper'>
            <Typography variant='body14' weight='semiBold'>Банк (бик - название банка)</Typography>
            <SelectWithChoice
                options={this.state.options}
                onInputChange={(value) => this.onInputChange(value)}
                currentInput={this.state.currentInput}
                onSelectOption={(key) => { this.onSelectOption(key) }}
                innerInputRef={undefined}
            />
            <Typography variant='body14' weight='semiBold'>Расчетный счет</Typography>
            <Typography variant='caption11'>20 символов</Typography>
            <input style={{ width: '60%' }} value={this.state.account} onChange={e => this.onAccountChange(e.target.value)} ref={this.accountNumberInput} />
            <div style={{ paddingTop: '10px' }}>
                <Button
                    size='small'
                    disabled={this.state.bankId < 1 || this.state.account.length != 20}
                    onClick={() => { this.props.onSave({ account: this.state.account, bankId: this.state.bankId }) }}
                >Сохранить счет</Button>
            </div>
        </div>
    }
}